<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { RotateCcw } from 'lucide-vue-next'
import AppModal from '@/components/shared/AppModal.vue'
import AppConfirmationContent from '@/components/shared/AppConfirmationContent.vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['cancel', 'confirm', 'update:visible'])

function cancel() {
  emit('cancel')
  emit('update:visible', false)
}

function confirm() {
  emit('confirm')
}
</script>

<template>
  <AppModal
    :visible="props.visible"
    @update:visible="emit('update:visible', $event)"
    @close="cancel"
    title="Confirm Restore Defaults"
    description="This action will reset all local configurations"
    max-width="max-w-xl"
    height="h-auto"
    main-class="p-0"
    :z-index="2000"
  >
    <AppConfirmationContent
      variant="warning"
      :icon="RotateCcw"
      message="Are you sure you want to restore all defaults? This will clear all local overrides and reload the page."
    />

    <!-- Sticky Footer -->
    <div class="p-6 pt-2 border-t border-gray-100 dark:border-white/5 bg-white dark:bg-gray-950/80 backdrop-blur-md">
      <Button
        class="w-full h-12 rounded-xl text-base font-bold shadow-lg shadow-red-500/20"
        variant="destructive"
        @click="confirm"
      >
        Restore Defaults
      </Button>
    </div>
  </AppModal>
</template>
